import { http } from './http';

const controller = '/edoc/web-configs';

export const getResourceConfig = async () => await http.get(`${controller}/get-config`);

export const addResourceConfig = async (config) => await http.post(`${controller}`, config);

export const updateResourceConfig = async (config) => await http.put(`${controller}/${config.id}`, config);
